<template>
    <div class="main-content">
        <div class="row">
            <div class="col-xs-12 m-b-sm">
                <div class="row table-filter">
                    <div class=" col-xs-12">
                        <h4 class="table-name">{{title}}</h4>
                    </div>
                </div>
                <div class="b-b"></div>
            </div>
            <transition name="fade">
                <div class="col-xs-12" style="display:none;" :style="view_mounted">
                    <form action="">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-xs">
                                    岗位名称:
                                </div>
                                <div class="col-xs-10  n-p-l p-t-xs label-text">
                                    {{post.name}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-xs">
                                    岗位别名:
                                </div>
                                <div class="col-xs-10  n-p-l p-t-xs label-text">
                                    {{post.alias}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-xs ">
                                    答题时间:
                                </div>
                                <div class="col-xs-5 n-p-l p-t-xs label-text">
                                    {{post.duration === -1 ? '不限时':post.duration + '（s）'}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-xs ">
                                    岗位类型:
                                </div>
                                <div class="col-xs-5 n-p-l p-t-xs label-text">
                                    {{post.post_category === 1 ? '系统内置': '公司'}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-if="post.post_category === 2">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-xs ">
                                    发布人:
                                </div>
                                <div class="col-xs-5 n-p-l p-t-xs label-text">
                                    {{(post.post_owner ? post.post_owner.realname:'管理员')}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-if="post.post_category === 2">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-xs ">
                                    测评次数:
                                </div>
                                <div class="col-xs-5 n-p-l p-t-xs label-text">
                                    {{post.evaluate_num}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-b-sm">
                                    关联能力群:
                                </div>
                                <div class="col-xs-8 n-p-l p-t-xs">
                                    <div class="col-xs-12 m-t-sm list-group">
                                        <div class="list-group-item row" v-for="(ability,ind) in post.abilities" :key="ability.ability._id">
                                            <div class="btn col-xs-12 n-b-r btn-md" :class="{'btn-success': ind % 3 === 0,'btn-warning':ind % 3 === 1,'btn-danger':ind%3 === 2}">
                                                <div class="row">
                                                    <div class="col-xs-6">{{ability.ability.name}}</div>
                                                    <div class="col-xs-6">
                                                        <div class="row">
                                                            <div class="col-xs-6"></div>
                                                            <div class="col-xs-6">
                                                                <span>权重:</span>
                                                                <span class="bold">{{ability.weight}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 m-t-sm list-group-sub">
                                                <div class="list-group-sub-item" v-for="(indicator,ind) in ability.indicators" :key="indicator.indicator._id">
                                                    <div class="btn col-xs-12 n-f" :class="{'btn-success': ind % 3 === 2,'btn-warning':ind % 3 === 1,'btn-danger':ind%3 === 0}">
                                                        <div class="row">
                                                            <div class="col-xs-6">{{indicator.indicator.name}}</div>
                                                            <div class="col-xs-6">
                                                                <span>权重:</span>
                                                                <span class="bold">{{indicator.weight}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class=" b-b b-dashed"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-xs">
                                    岗位说明:
                                </div>
                                <div class="col-xs-10 n-p-l p-t-xs label-text">
                                    <div v-html="post.desc"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center">
                            <div class="btn btn-primary btn-sm" @click="back()">返回</div>
                        </div>
                    </form>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Post from '../../../resource/post'

export default {
    data: function () {
        return {
            title: '查看岗位',
            post: {
            }, // 岗位
            view_mounted: { 'display': 'none' }
        }
    },
    computed: {
        ...mapGetters({
            'user': 'loginUser'
        })
    },
    created: function () {
        let that = this
        if (that.user.category === 2 || that.user.role === 2 || that.user.role === 3) {
            if (that.$route.params._id) {// edit
                that.action = 'edit'
                Post.full({ "_id": that.$route.params._id }).then(res => {
                    let data = res.body
                    if (data.code === 0) {
                        that.post = data.result
                        document.title = `岗位：${that.post.name}-企业控制台|${that.global.name}`
                        that.title = `岗位展示：${that.post.name}`
                    } else {
                        alert(data.msg)
                    }
                }, res => { })
            } else {
                that.$router.replace('/company/posts')
            }
        } else {
            that.$router.replace('/')
        }
    },
    methods: {
        back: function () {
            this.$router.push('/company/posts')
        }
    },
    mounted: function () {
        let that = this
        that.view_mounted = { display: 'block' }
    }
}
</script>
<style lang="less" scoped>
.invitate-code {
    padding-left: 15px;
    padding-right: 15px;
    &.code_is_active {
        color: #42b983;
    }
}


.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */

{
    opacity: 0
}
</style>



// WEBPACK FOOTER //
// show.vue?4a5565ff